import {makeAutoObservable} from "mobx";
import Image from "../models/Image";
import Accordion from "../models/Accordion";
import agent from "../api/agent";

export default class ImageStore {
    images: Map<number, Image[]> = new Map<number, Image[]>();
    constructor() {
        makeAutoObservable(this);
    }

    public async loadImagesOfAccordion(accordion: Accordion): Promise<Image[]>{
        //@ts-ignore
        if(this.images.has(accordion.id)) return this.images.get(accordion.id);
        const images: Image[] = await agent.Images.findOfAccordion(accordion.id);
        if(!images) return [];
        if(images.length > 0) this.setImages(accordion.id, images);
        return images;
    }

    public setImages(accordionId: number, images: Image[]): void {
        this.images.set(accordionId, images);
    }

    public async create(image: Image, accordionId: number): Promise<void> {
        const newImage = await agent.Images.create(image);
        const images = this.images.get(accordionId);
        if(!images) return;
        images.push(newImage);
        this.setImages(accordionId, images);
    }

    public async delete(imageId: number, accordionId: number){
        const imagesOfAccordion = this.images.get(accordionId);
        if(!imagesOfAccordion) return;
        await agent.Images.del(imageId);
        this.setImages(accordionId, imagesOfAccordion.filter(a => a.id !== imageId));
    }

}